import { useServicesQuery } from '@/services/api';
import type { ServicesApiGetEnvHealthQueryParams } from '@/services/api/services-api';
import { WORKSPACE_HEALTH_REFETCH_INTERVAL_ACTIVE } from '../constants';

export function useEnvHealthObjects(
  workspaceId: number,
  simulate: ServicesApiGetEnvHealthQueryParams['simulate'],
  enabled = true,
) {
  return useServicesQuery(
    'getEnvHealthObjects',
    { params: { environment_id: workspaceId }, query: { simulate } },
    {
      refetchInterval: WORKSPACE_HEALTH_REFETCH_INTERVAL_ACTIVE,
      enabled: workspaceId > 0 && enabled,
      refetchOnWindowFocus: 'always',
    },
  );
}
